import React from "react";
import {
  Link,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Checkbox,
  FormControlLabel,
  useTheme,
} from "@material-ui/core";

import { guestmeOfferUrl } from "../../../config/constants";
import { Employees, GuestmeOffer } from "../../../entities";
import { useRestaurant, useRestaurantId } from "../../../selectors/RestaurantSelectors";

export function GuestmeOfferWidget() {
  const theme = useTheme();
  const [isOfferAccepted, setIsOfferAccepted] = React.useState(false);
  const restaurantId = useRestaurantId();
  const currentRestaurant = useRestaurant();
  const { data: currentEmployee } = Employees.useCurrentEmployee();
  const isAdmin = currentEmployee ? Employees.isAdmin(currentEmployee) : false;
  const isEligibleToAsk = currentRestaurant?.saleSource !== 'IIKO' && isAdmin;
  const guestmeOffer = GuestmeOffer.useGuestmeOffer(isEligibleToAsk);
  const guestmeAcceptOffer =
    GuestmeOffer.useAcceptGuestmeOfferMutation(restaurantId);

  if (!isEligibleToAsk || guestmeOffer?.data || guestmeOffer.isLoading) {
    return null;
  }

  const handleAccept = () => guestmeAcceptOffer.mutate();

  return (
    <Dialog open style={{ minWidth: 400 }}>
      <DialogTitle>Внимание</DialogTitle>
      <DialogContent
        dividers
        style={{
          paddingBottom: theme.spacing(1),
          color: "#323232",
        }}
      >
        <Box mb={2}>
          Для работы с&nbsp;сервисом вам необходимо ознакомиться
          и&nbsp;согласиться с&nbsp;
          <Link
            href={guestmeOfferUrl}
            target="_blank"
            rel="noreferrer"
            style={{ color: "rgba(37, 80, 255, 1)" }}
          >
            условиями оферты
          </Link>
        </Box>

        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={isOfferAccepted}
              onChange={(event, checked) => setIsOfferAccepted(checked)}
            />
          }
          label={
            <>
              Я ознакомился и&nbsp;принимаю{" "}
              <Link
                href={guestmeOfferUrl}
                target="_blank"
                rel="noreferrer"
                style={{ color: "rgba(37, 80, 255, 1)" }}
              >
                условия оферты
              </Link>
            </>
          }
        />
      </DialogContent>
      <DialogActions>
        <Box paddingX={2} paddingY={1} width="100%">
          <Button
            onClick={handleAccept}
            variant="contained"
            color="primary"
            style={{
              paddingLeft: theme.spacing(3),
              paddingRight: theme.spacing(3),
            }}
            disabled={!isOfferAccepted}
          >
            Принять
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
